/* eslint-disable react/no-array-index-key */

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import MainLayout from 'components/MainLayout'
import { Container } from 'components/layout/Grid/'
import BackToAdminCentre from 'components/BackToAdminCentre'
import RouteWithSubRoutes from 'components/RouteWithSubRoutes'
import { resetErrorMessage, setErrorMessage } from 'actions/app'
import { modalShow, modalHide } from 'actions/modals'
import { getPartnerPlanRatingVisibility, editPartnerPlanRatingVisibility } from 'actions/partnerPlanRatingVisibility'
import { getFiscalYearTimestamps } from 'utils/fiscalYear'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { hasAccess } from 'utils/hasAccess'
import constants from 'constants'
import { getEmployeeId } from 'utils/getEmployeeId'

class PartnerPlanRatingVisibility extends Component {
  static propTypes = {
    accountsAndLoans: PropTypes.object.isRequired,
    currentUser: PropTypes.object,
    editPartnerPlanRatingVisibility: PropTypes.func.isRequired,
    getPartnerPlanRatingVisibility: PropTypes.func.isRequired,
    modalHide: PropTypes.func.isRequired,
    modalShow: PropTypes.func.isRequired,
    routes: PropTypes.instanceOf(Array),
    setErrorMessage: PropTypes.func.isRequired,
  }
  static defaultProps = {
    routes: {},
    currentUser: null,
  }
  componentDidMount() {
    hasAccess(this.props.currentUser, 'ADMN: Partner Plan rating visibility', this.props.history, 'RW', true)
    this.props.getPartnerPlanRatingVisibility(
      getEmployeeId(this.props.selectedPartner, this.props.currentUser),
      (getFiscalYearTimestamps().current.year - constants.PARTNERPLAN.PLAN_FILTER_PARTNER_YEAR),
    )
  }

  handleUpdatePartnerPlanRatingVisibility = (data) => {
    const updateItem = {
      ...data,
      employee_id: getEmployeeId(this.props.selectedPartner, this.props.currentUser),
      ids: data.ID,
      enabled: !data.enabled,
    }

    if (updateItem) {
      this.props.editPartnerPlanRatingVisibility(updateItem)
    }
  }

  bannerProps = () => {
    const {
      routes, history, location, match, path,
    } = this.props
    return {
      name: 'Admin centre',
      history,
      location,
      path,
      match,
      routes,
    }
  }

  render() {
    const {
      routes, partnerPlanRatingVisibility, currentUser,
    } = this.props

    return (
      <MainLayout bannerNavProps={{ ...this.bannerProps() }} showSidebar={false} sidebarType="partnerSideBar">
        <BackToAdminCentre displayText={constants.PARTNERPLAN.FORMHEADER.RATINGVISIBILITY} isAdmin={this.props.currentUser.IsAdmin} />
        <Container>
          {routes.map((route, i) => (
            <RouteWithSubRoutes
              key={i}
              {...route}
              currentUser={currentUser}
              getPartnerPlanRatingVisibility={this.props.getPartnerPlanRatingVisibility}
              partnerPlanRatingVisibility={partnerPlanRatingVisibility}
              setErrorMessage={this.props.setErrorMessage}
              updatePartnerPlanRatingVisibility={this.handleUpdatePartnerPlanRatingVisibility}
            />
            ))}
        </Container>
      </MainLayout>
    )
  }
}

const mapStateToProps = state => ({
  errorMessage: state.errorMessage,
  partnerPlanRatingVisibility: state.partnerPlanRatingVisibility,
  editPartnerPlanRatingVisibility: state.editPartnerPlanRatingVisibility,
})

export default withRouter(connect(mapStateToProps, {
  resetErrorMessage,
  setErrorMessage,
  getPartnerPlanRatingVisibility,
  editPartnerPlanRatingVisibility,
  modalShow,
  modalHide,
})(PartnerPlanRatingVisibility))



// WEBPACK FOOTER //
// ./src/containers/PartnerPlanRatingVisibility.js